import { faGraduationCap } from "@fortawesome/pro-solid-svg-icons/faGraduationCap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Grid, Typography } from "@mui/material";
import * as api from "api/Core";
import AdvFilter, { AdvFilterCommand, AdvFilterComponent, AdvFilterResult, AutoCompleteKeyWord } from "components/AdvFilter";
import { CmdAccountBlocked } from "components/AdvFilter/CommonCommands";
import IconButtonBack from "components/Buttons/IconButtonBack";
import IconButtonBlocked from "components/Buttons/IconButtonBlocked";
import IconButtonCancel from "components/Buttons/IconButtonCancel";
import { MuiFilterAdvancedContainer } from "components/MuiExtras/Filter";
import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiPaper from "components/MuiExtras/MuiPaper";
import MuiColor from "components/MuiExtras/Typography/MuiColor";
import * as React from "react";
import { WithTranslation } from "react-i18next";
import Session from "services/Session";

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    onFilterChange: (filter: AdvFilterResult[]) => void;
    advFilters: AdvFilterResult[];
    commands: AdvFilterCommand[];
}

type Props = IProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////

class CourseAnalysisFilter extends React.PureComponent<Props> {

    private apiGetSuggestions = api.getCourseSuggestions();

    ///
    public advFilterRef: AdvFilterComponent = null;

    ///
    constructor(props: Props) {
        super(props);
        this.state = {
            advFilters: [],
        };
    }

    ///
    private cancelSelection = () => {
        var advFilters = this.props.advFilters.filter(p => p.keyword != AutoCompleteKeyWord);
        this.props.onFilterChange(advFilters);
    };

    ///
    private cancelFilter = () => {
        var advFilters = this.props.advFilters.filter(p => p.keyword == AutoCompleteKeyWord);
        this.setState({ advFilters }, () => this.props.onFilterChange(advFilters));
    };

    ///
    private updateFilter = (inputValue: string, advFilters: AdvFilterResult[]) => {

        this.setState({ advFilters }, () => this.props.onFilterChange(advFilters));
    };

    ///
    private handleBlockedFilter() {
        const advFilters = this.props.advFilters;
        var isBlocked = advFilters.find(x => x.keyword == CmdAccountBlocked) != null;

        var newAdvFilter: AdvFilterResult[];

        if (isBlocked)
            newAdvFilter = advFilters.filter(x => x.keyword != CmdAccountBlocked);
        else {
            newAdvFilter = advFilters.slice(0);
            newAdvFilter.push({ keyword: CmdAccountBlocked, text: this.props.t("Views.Dashboards.CourseAnalysis.Filter.AccountBlocked") } as AdvFilterResult);
        }

        this.setState({ advFilters: newAdvFilter }, () => this.props.onFilterChange(newAdvFilter));
    };

    ///
    private getSuggestions = (searchText: string, skipRecords: number, takeRecords: number): Promise<AutoCompleteDataModel[]> => {
        const inputValue = searchText.trim().toLowerCase();
        return this.apiGetSuggestions.execute({
            userId: Session.user.id,
            searchText: inputValue,
            offset: skipRecords,
            take: takeRecords
        });
    };

    ///
    public componentDidUpdate(prevProps: Props) {
        if (this.props.commands.some(p => prevProps.commands.findIndex(x => x.keyword == p.keyword) == -1))
            this.cancelFilter();
    }

    ///
    public render() {
        const { advFilters, commands } = this.props;
        var autoComplete = advFilters.find(p => p.keyword == AutoCompleteKeyWord);
        var currentAutoCompleteSelected = autoComplete == null ? null : autoComplete.value;
        var filtered = advFilters.filter(p => p.keyword != AutoCompleteKeyWord).length > 0;
        const filterBlocked = advFilters.find(x => x.keyword == CmdAccountBlocked) != null;

        return (
            <MuiContainer>

                <MuiPaper borderVariant="square" borderColor="info">

                    <Grid container justifyContent="space-between" spacing={2}>
                        <Grid item>
                            <div style={{ width: 64, height: 64 }}>
                                {
                                    currentAutoCompleteSelected && currentAutoCompleteSelected.thumbnailUrl
                                        ? <img src={currentAutoCompleteSelected.thumbnailUrl} alt={currentAutoCompleteSelected.label} width={64} height={64} />
                                        : <MuiColor variant={currentAutoCompleteSelected ? "warning" : "info"}><FontAwesomeIcon icon={faGraduationCap} size="3x" /></MuiColor>
                                }
                            </div>
                        </Grid>
                        <Grid item xs>
                            <Grid container>
                                <Grid item xs>
                                    <Typography variant="button">{this.props.t("Views.Dashboards.CourseAnalysis.AnalysisFilter.HeaderTitle")}</Typography>
                                </Grid>
                                <Grid item>
                                    <IconButtonBlocked
                                        color={filterBlocked ? "warning" : "muted"}
                                        title={this.props.t("Views.Dashboards.CourseAnalysis.Filter.AccountBlocked")}
                                        size="small"
                                        onClick={() => this.handleBlockedFilter()}
                                    />
                                </Grid>
                            </Grid>

                            <MuiFilterAdvancedContainer disableMargins>
                                <Grid container justifyContent="space-between" alignItems="center" spacing={1}>
                                    {
                                        currentAutoCompleteSelected &&
                                        <Grid item>
                                            <IconButtonBack title={this.props.t("Views.Dashboards.Common.ResetSelectedCourse")} onClick={this.cancelSelection} size="small" />
                                        </Grid>
                                    }

                                    <Grid item xs>
                                        <AdvFilter
                                            id="advfilter"
                                            commands={commands}
                                            innerRef={(ref) => this.advFilterRef = ref}
                                            placeHolder={currentAutoCompleteSelected == null ? this.props.t("Views.Dashboards.Common.AllCourses") : currentAutoCompleteSelected.label}
                                            placeHolderFocus={this.props.t("Views.Dashboards.CourseAnalysis.AnalysisFilter.AdvFilterPlaceholderFocus")}
                                            title={this.props.t("Common.Filter.Adv.InputTitleEnterToFilter")}
                                            underlineColor="black"
                                            selectedCommands={this.props.advFilters}
                                            onUpdateSelection={this.updateFilter}
                                            autocomplete={
                                                {
                                                    tokenizeSelection: false,
                                                    onGetSuggestions: this.getSuggestions
                                                }
                                            }
                                        />
                                    </Grid>

                                    {
                                        filtered &&
                                        <Grid item>
                                            <IconButtonCancel onClick={this.cancelFilter} size="small" />
                                        </Grid>
                                    }
                                </Grid>
                            </MuiFilterAdvancedContainer>

                        </Grid>
                    </Grid>
                </MuiPaper>
            </MuiContainer>
        );
    }
}

export default CourseAnalysisFilter;